export enum EditorStyles {
  Bold = "*",
  Italic = "_",
  StrikThrough = "~",
  Code = "```",
  Emoji = `EMOJI`
}

